import React from 'react';
import SvgIcon from './svgIcon';

const SvgList = props => {
  return (
    <SvgIcon width={27} height={18} {...props}>
      <g
        strokeLinejoin="round"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2px"
      >
        <path
          data-name="Line 179"
          transform="translate(8 1)"
          d="M0 0h18"
        />
        <path
          data-name="Line 180"
          transform="translate(8 9)"
          d="M0 0h18"
        />
        <path
          data-name="Line 181"
          transform="translate(8 17)"
          d="M0 0h18"
        />
        <path
          data-name="Line 182"
          transform="translate(1 1)"
          d="M0 0h0"
        />
        <path
          data-name="Line 183"
          transform="translate(1 9)"
          d="M0 0h0"
        />
        <path
          data-name="Line 184"
          transform="translate(1 17)"
          d="M0 0h0"
        />
      </g>
    </SvgIcon>
  );
};

export default SvgList;
